import { formatMoney, type Invitation, type InvitationDraft, type Locale } from '@debtbot/shared';
import type { Dictionary } from '../i18n';

/**
 * Что уходит в share-sheet. Приглашённый должен попасть сразу в Mini App, поэтому берём
 * link_app (t.me/<bot>/app?startapp=inv_…), а не link_bot (?start= открывает чат с ботом).
 */
export function inviteLink(inv: Pick<Invitation, 'link_app'>): string {
  return inv.link_app;
}

/**
 * Системный шаринг Telegram. Клиент собирает сообщение как `<url>\n<text>` — ссылка идёт
 * первой, поэтому текст не должен её дублировать.
 */
export function buildShareUrl(link: string, text: string): string {
  // Только encodeURIComponent: URLSearchParams кодирует пробел как `+`,
  // а Telegram iOS показывает плюсы в тексте как есть.
  return `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(text)}`;
}

/** Полное сообщение для буфера обмена (fallback вне Telegram). */
export function inviteMessage(text: string, link: string): string {
  return `${text}\n${link}`;
}

/**
 * Текст приглашения: с черновиком — «я записал: ты → мне / я → тебе <сумма>, <заметка>»
 * с точки зрения приглашающего, без черновика — общий текст. Ссылку не содержит — её
 * Telegram ставит первой строкой (buildShareUrl), а fallback добавляет сам (inviteMessage).
 */
export function inviteShareText(
  d: Dictionary,
  locale: Locale,
  draft: InvitationDraft | null,
): string {
  if (!draft) return d.home.shareText;
  const sum = formatMoney(draft, { withCurrency: true, locale });
  return draft.payer === 'inviter'
    ? d.home.shareDraftIPaid(sum, draft.note)
    : d.home.shareDraftPeerPaid(sum, draft.note);
}
